import { ReactNode } from 'react';

import { TITULO_DE_SECAO } from 'styles';

interface CabecalhoDaSecaoProps {
  id?: string;
  titulo: ReactNode;
  subtitulo?: ReactNode;
  /** Link ou botão "Ver todos…" à direita. */
  acao?: ReactNode;
}

/** Título, subtítulo e ação das seções do Resumo, como no Meu Perfil v2. */
export default function CabecalhoDaSecao({ id, titulo, subtitulo, acao }: CabecalhoDaSecaoProps) {
  return (
    <div className="mb-3 flex flex-wrap items-end justify-between gap-4">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <h2 id={id} className={TITULO_DE_SECAO}>
          {titulo}
        </h2>
        {subtitulo && <p className="m-0 text-[13px] text-content">{subtitulo}</p>}
      </div>
      {acao}
    </div>
  );
}

/** Classe do link/botão de ação do cabeçalho ("Ver todos os reconhecimentos"). */
export const ACAO_DO_CABECALHO =
  'flex cursor-pointer items-center gap-2 whitespace-nowrap border-0 bg-transparent p-0 font-display text-xs font-bold uppercase tracking-[0.05em] text-brand-blue-dark';

/** Seta do link de ação, decorativa. */
export function SetaDaAcao() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}
